module.exports = {
      id: "logo-badge-usage",
      viewBox: "0 0 415 421",
      url: __webpack_public_path__ + "img/icons.26b8852d.svg#logo-badge-usage",
      toString: function () {
        return this.url;
      }
    }